// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile =  {
    "aws_project_region": "us-west-2",
    "aws_dynamodb_all_tables_region": "us-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "cmp-v2-audiences",
            "region": "us-west-2"
        },
        {
            "tableName": "cmp-v2-clients",
            "region": "us-west-2"
        },
        {
            "tableName": "cmp-v2-audiences-query-hash",
            "region": "us-west-2"
        },
        {
            "tableName": "cmp-v2-users",
            "region": "us-west-2"
        }
    ],
    "aws_user_files_s3_bucket": "prod-cog-messages1",
    "aws_user_files_s3_bucket_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "prodcmpapp",
            "endpoint": "https://olsp04vkae.execute-api.us-west-2.amazonaws.com/Prod",
            "region": "us-west-2"
        }
    ],
    aws_cognito_identity_pool_id:
    "us-west-2:7b4a1b78-377a-4b6b-9211-fd70075b6ef3",
    aws_cognito_region: "us-west-2",
    aws_project_name: "v2-cmp-io-user-pool",
    //   aws_project_region: "us-west-2",
    aws_resource_name_prefix: "v2-cmp-io-user-pool",
    aws_sign_in_enabled: "enable",
    aws_user_pools: "enable",
    aws_user_pools_id: "us-west-2_nmU7IEO00",
    aws_user_pools_mfa_type: "ON",
    aws_user_pools_web_client_id: "5uonepqoql839g1ku5qrd88cae"
    //"aws_cognito_identity_pool_id": "us-west-2:043244f8-b7b0-4cc3-aae0-5be025c09a0c",
    //"aws_cognito_region": "us-west-2",
    //"aws_user_pools_id": "us-west-2_tU1vaAvf2",
    //"aws_user_pools_web_client_id": "6ehmov1q731ndshqqju95eb5ju"
};


export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js